import { render, staticRenderFns } from "./DashboardReportLayout.vue?vue&type=template&id=5013661e&scoped=true"
import script from "./DashboardReportLayout.vue?vue&type=script&lang=js"
export * from "./DashboardReportLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5013661e",
  null
  
)

export default component.exports